import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import Text from '../../typography'
import styled from '@emotion/styled';
import { theme } from '../../../themes/default-theme';
import {Grid, Box} from '@mui/material';
import { Cta } from '../../ui';
import Link from 'next/link';
import ReactHtmlParser from 'react-html-parser';

const Wrapper = styled.div`
`

const Container = styled.div`
    text-align: center;
`
const BodyTextContent = styled.div`
    margin: 20px 0;
`

const seriesBodyTextDefaultPropLink = {};

const SeriesBodyText = (props) => {
    props = {
        ...props,
        background: typeof props.background === "undefined" ? null : props.background,
        title: typeof props.title === "undefined" ? null : props.title,
        preTitle: typeof props.preTitle === "undefined" ? null : props.preTitle,
        content: typeof props.content === "undefined" ? null : props.content,
        link: typeof props.link === "undefined" ? seriesBodyTextDefaultPropLink : props.link,
        colourTheme: typeof props.colourTheme === "undefined" ? 'light' : props.colourTheme
    };

    const {
        background,
        title,
        preTitle,
        content,
        link,
        colourTheme        
    } = props;

    const mainFontColour = (colourTheme === 'light' && background !== 'black') ? 'charcoal' : (colourTheme !== 'light' && background === 'black') ? 'white' : 'white'

    return (
        <>
            <Wrapper>
                <Container background={background}>
                    <Grid container direction={'row'}>
                        <Grid size={12}>
                            {preTitle &&
                                <Box px={2}>
                                    <Text variant="subTitle" colour={"vividBlue"} uppercase="true" align="center">{preTitle}</Text>
                                </Box>
                            }
                            {title &&
                                <Box px={2}>
                                    <Text variant="h2" weight={800} colour={mainFontColour} uppercase="true" align="center">{title}</Text>
                                </Box>
                            }
                            {content &&
                                <BodyTextContent>
                                    <Box px={2}>
                                        <Text variant="body1" colour={mainFontColour} align="center">{ReactHtmlParser(content)}</Text>                                
                                    </Box>
                                </BodyTextContent>
                            }
                            {link && link.title &&
                                <Cta inline href={link.href || '#'} target={link.target}>
                                    {link.title}
                                </Cta>
                            }
                        </Grid>
                    </Grid>
                </Container>
            </Wrapper>
        </>
    );
}

SeriesBodyText.propTypes = {
  background: propTypes.string,
  title: propTypes.string,
  preTitle: propTypes.string,
  content: propTypes.string,
  link: propTypes.object,
  colourTheme: propTypes.string
}

export default SeriesBodyText